import script from "./DepositUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositUser.vue?vue&type=script&setup=true&lang=js"

import "./DepositUser.vue?vue&type=style&index=0&id=1cdf3604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdf3604"]])

export default __exports__